const PaymentPlatforms = {
  stripe: 'stripe',
  spreedly: 'spreedly',
  payfabric: 'payfabric',
  rectangle: 'rectangle',
};

export default PaymentPlatforms;
